const KAYAK = 'kayak';

const wanderuPartners = {
    [KAYAK]: { enabled: false },
};

const isPartnerEnabled = (
    partnerId,
    partners = wanderuPartners,
) => partners[partnerId]
    ? partners[partnerId].enabled
    : true;

export { isPartnerEnabled, wanderuPartners };
